/*
  An Ad Manager line item is live if in a live status or deliveryIndicator is set.
  An order is live if any placement in it is live.
  A placement has been pushed if it has one or more Ad Manager Line Item IDs.
  A programmatic line item is locked when finalized (buyer has accepted) until reopened.
 */
import { isEmpty } from 'lodash';

const amLiveStatuses = [
  'COMPLETED',
  'DELIVERING',
  'DELIVERY_EXTENDED',
  // 'READY'  READY may not be started
];
const amIndeterminateStatuses = [
  'PAUSED',
  'PAUSED_INVENTORY_RELEASED',
  'READY'
];

export const isLiveOrder = placements => placements && placements.some(p => isDelivering(p));

export const isDelivering = p => {
  if (!p.LineItems || p.LineItems.length === 0 || !p.LineItems[0].adManagerStatus) {
    return false;
  }
  const status = p.LineItems[0].adManagerStatus;
  if (status === 'INACTIVE'){
    return false;
  }
  if (amLiveStatuses.includes(status)) {
    return true;
  }
  const delInd = p.LineItems[0].deliveryIndicator;
  return amIndeterminateStatuses.includes(status) && (delInd !== -1 && delInd !== null);
}

export const isPushed = p => p && p.LineItems && !isEmpty(p.LineItems.map(li => li.adManagerLineitemId).filter(Boolean));

export const isLockedOrder = order =>
  order &&
  order.orderType === 'Programmatic' &&
  order.dfpProposalStatus === 'FINALIZED' &&
  order.dfpReopenStatus !== 'Reopened';
